module.exports = __webpack_public_path__ + "img/20200609_114630.3f28ec75.jpg";